 export const BASE_URL="https://healthistic.onrender.com"

// export const BASE_URL="http://localhost:8080"
